export default __webpack_public_path__ + "static/media/NC_512x512.9eec6abd.png";